var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "position-relative d-inline-flex align-middle",
      on: {
        mouseover: _vm.showTooltip,
        mouseleave: _vm.hideTooltip,
        focus: _vm.showTooltipFocus,
        blur: _vm.hideTooltipBlur,
        click: _vm.toggleTooltipClick,
      },
    },
    [
      _vm._t("icon", function () {
        return [
          _c("i", {
            staticClass: "far fa-info-circle text-info cursor-pointer",
          }),
        ]
      }),
      _vm._v(" "),
      _vm.show
        ? _c(
            "div",
            {
              staticClass: "tooltip show vue-tooltip",
              class: "tooltip-" + _vm.position,
              attrs: { id: _vm.id },
            },
            [
              _c("div", { staticClass: "vue-tooltip-arrow arrow" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tooltip-inner" },
                [_vm._t("tooltip-content")],
                2
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }